import { Locale } from 'src/types'

import { ServiceType } from 'src/pages/ServiceMaintenance/enums'

export const maintenanceDictionaryType = (
  locale: Locale['maintenance'],
): Record<ServiceType, string> => {
  const { oilItem, filterItem, tireItem, repair } = locale.addMaintenance

  return {
    [ServiceType.OIL_CHANGE]: oilItem,
    [ServiceType.FILTER_CHANGE]: filterItem,
    [ServiceType.TIRE_CHANGE]: tireItem,
    [ServiceType.REPAIR]: repair,
  }
}
